import React from 'react';
import { Globe, Layout, Gamepad2, GraduationCap } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  Globe: Globe,
  Layout: Layout,
  Gamepad2: Gamepad2,
  GraduationCap: GraduationCap
};

const Services = () => {
  return (
    <section id="services" className="section-large">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What We Do
          </h2>
          <div className="w-20 h-1 bg-accent-teal mx-auto mb-6"></div>
          <p className="text-lg text-neutral-silver max-w-2xl mx-auto">
            We transform ideas into exceptional digital experiences across multiple platforms
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-xl bg-accent-teal/10 flex items-center justify-center">
                      <IconComponent size={28} className="text-accent-teal" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-3">{service.title}</h3>
                    <p className="text-neutral-silver leading-relaxed">{service.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
